/**
 * ApplicationInstance ROUTES
 */
const routes = [
  //ApplicationInstance
  {
    path: '/ApplicationInstance/Filter',
    name: 'ApplicationInstanceViewComponent',
    component: 'ApplicationInstance/ApplicationInstanceViewComponent'
  },
  {
    path: '/ApplicationInstance/Editor/:Id?',
    name: 'ApplicationInstanceEditorViewComponent',
    component: 'ApplicationInstance/ApplicationInstanceEditorViewComponent',
    props: true
  }
];

export default routes;
